export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "https://unranked.io";

export const API_URL =
	process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || "https://api.unranked.io";
